var CryptoJS = require("crypto-js");

document.addEventListener("turbolinks:load", () => {

  var time_display = 3;
  var delay_before_first_show = 30000;
  var delay_between_visits = 3600000;
  var day_before_cookie_expire = 360;
  var display_pop_in = null;
  var timer_allready_elapsed_time = null;
  var json_pop_in = {
    timestamp: null,
    count: null,
    hide: false,
    already_elapsed_time: 0
  };

  if ($('#pop-in-modal').length){
    var check_tarteaucitron_cookie = setInterval(checking_cookie,1000);
    $('#pop-in-login-button').on( "click", function() {
      $('#pop-in-modal').modal('hide');
      $('#user').click();
    });
    $('#discard-pop-in').on( "click", function() {
      $('#pop-in-modal').modal('hide');
      json_pop_in.hide = true
      update_club_des_societaires_cookie();
      clearInterval(display_pop_in);
    });
  };

  if ($('#pop-in-my-sys').length && readCookie("my-sys-modal") == null) {
    setTimeout(show_my_sys_pop_in, 1000);
  };

  $('#pop-in-my-sys-discard-header').on( "click", function() {
    $('#pop-in-my-sys').modal('hide');
    setCookie('my-sys-modal', 'seen', 2);
  });

  $('#pop-in-my-sys-discard-footer').on( "click", function() {
    $('#pop-in-my-sys').modal('hide');
    setCookie('my-sys-modal', 'seen', 2);
  });

  if (document.cookie.indexOf('club_des_societaires=') != -1) {
    actualise_json_pop_in();
  } else {
    update_club_des_societaires_cookie();
  }

  function checking_cookie(){
    if (document.cookie.indexOf('club_des_societaires_cmp=') != -1){
      cookie_value = readCookie('club_des_societaires_cmp');
      cookie_all_set = true
      cookie_value.split("!").filter(function(e){return e!=""}).forEach(function(service){ result_serv=service.split("="); if(cookie_all_set == true && result_serv[1]== "wait"){cookie_all_set=false}})
      tarteaucitron_visibled = $('#tarteaucitronAlertBig').is(":visible") && $('#tarteaucitron').is(":visible")
      if(cookie_all_set && !tarteaucitron_visibled){
        clearInterval(check_tarteaucitron_cookie);
        timer_allready_elapsed_time = setInterval(increase_already_elapsed_time,1000);
        resumed_timer_before_first_show = delay_before_first_show - (json_pop_in['already_elapsed_time']*1000)
        display_pop_in = setInterval(show_pop_in,resumed_timer_before_first_show);
      }
    };
  };

  function increase_already_elapsed_time(){
    json_pop_in.already_elapsed_time +=1 ;
    update_club_des_societaires_cookie();
  }

  function show_pop_in(){
    actualise_json_pop_in();
    clearInterval(display_pop_in);
    clearInterval(timer_allready_elapsed_time);
    if(json_pop_in.hide){
      return;
    }
    if(json_pop_in.count < time_display){
      json_pop_in.already_elapsed_time = 0;
      json_pop_in.count = parseInt(json_pop_in.count)+1;
      update_club_des_societaires_cookie();
      $('#pop-in-modal').modal('show')
    };
  }

  function show_my_sys_pop_in(){
    $('#pop-in-my-sys').modal('show');
  }

  window.addEventListener("beforeunload", function (e) {
    update_last_visit();
    return null;
  });

  function actualise_json_pop_in(){
    var bytes  = CryptoJS.AES.decrypt(readCookie('club_des_societaires'), 'club_des_societaires_key');
    var originalText = bytes.toString(CryptoJS.enc.Utf8);
    json_pop_in = JSON.parse(originalText)
    json_pop_in.count = json_pop_in.count || 0;
    json_pop_in.hide = json_pop_in.hide || false;
    json_pop_in.already_elapsed_time = json_pop_in.already_elapsed_time || 0;
  }

  function update_last_visit(){
    if(document.cookie.indexOf('club_des_societaires=') != -1){
      actualise_json_pop_in();
      if( (Date.now() - parseInt(json_pop_in.timestamp)) > delay_between_visits){
        json_pop_in.timestamp = new Date().getTime();
        update_club_des_societaires_cookie();
      }
    }else{
      json_pop_in.timestamp = new Date().getTime();
      update_club_des_societaires_cookie();
    }
    return;
  }

  function update_club_des_societaires_cookie(){
    setCookie('club_des_societaires', CryptoJS.AES.encrypt(JSON.stringify(json_pop_in), 'club_des_societaires_key').toString(), day_before_cookie_expire);
  }

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

});
